import { useCallback } from 'react';
import { push as navigateTo } from 'connected-react-router';
import { useTranslation } from 'react-i18next';
import { useParams } from 'util/reactRouterHooks';
import { HasUrlSlug, getBuildingIdByUrlSlug } from 'selectors/buildingsSelectors';
import { useDispatch, useSelector } from 'react-redux';
import { useSession } from 'hooks';
import { Permission } from 'shared/permissions';
import { DebugLink } from 'ui/shared/DebugLink';
import { State } from 'reducers';

require('./DeviceTreeCommands.css');

export type Props = {
    onClickAdd(): void;
};

export const DeviceTreeCommands = ({ onClickAdd }: Props) => {
    const { t } = useTranslation();

    const params = useParams<HasUrlSlug>();

    const { hasPermission } = useSession();

    const buildingId = useSelector((state: State) => getBuildingIdByUrlSlug(state, params));

    if (!hasPermission(buildingId, Permission.CreateDevice)) {
        return null;
    }

    return (
        <div id="device-tree-commands">
            <button
                id="device-tree-add"
                className="ui basic button"
                onClick={ onClickAdd }
            >
                { t('COMMAND.ADD_DEVICE') }
            </button>

            <DebugLink
                sql={
                    `--[Building]\n` +
                    `SELECT * FROM buildings WHERE id = '${buildingId}';\n\n` +
                    `--[Device Groups]\n` +
                    `SELECT * FROM device_groups WHERE building_id = '${buildingId}';\n\n` +
                    `--[Devices]\n` +
                    `SELECT d.id, d.display_name, d.device_class, dt.display_name device_type, d.mac_address, ds.ip_address, group_id, dc.display_name config_name, ds.last_check_in, ds.status, ds.firmware, COALESCE(ds.theme_etag, ds.theme_name) theme_etag_or_name, d.properties\n` +
                    `FROM device_types dt, device_configs dc RIGHT JOIN devices d ON d.device_config_id = dc.id LEFT JOIN device_status ds ON d.id = ds.device_id\n` +
                    `WHERE d.device_type_id = dt.id AND d.building_id = '${buildingId}'\n` +
                    `ORDER BY group_id, d.device_class, d.display_name;\n\n` +
                    `--[Device Configs]\n` +
                    `SELECT * FROM device_configs WHERE building_id = '${buildingId}';\n`
                }
            />
        </div>
    );
};
